module.exports = __webpack_public_path__ + "img/raised.3cf2142f.svg";